module.exports = __webpack_public_path__ + "img/DE00830.d65b3bbb.png";